<template>
  <div>
    <Header>
      Dodawanie fryzjera
    </Header>

    <b-row>
      <b-col xl="6">
        <Errors/>

        <b-form @submit.prevent="submit">
          <b-form-group label="Imię">
            <b-input v-model="form.firstName" required/>
          </b-form-group>
          <b-form-group label="Nazwisko">
            <b-input v-model="form.lastName"/>
          </b-form-group>
          <b-form-group>
            <div class="d-flex justify-content-between">
              <div>
                <inertia-link
                  :href="route('barbers.index')"
                  as="b-button"
                  variant="secondary"
                >
                  <b-icon icon="x"/>
                  Anuluj
                </inertia-link>
              </div>
              <div>
                <b-button type="submit" variant="primary" :disabled="form.processing">
                  <b-icon icon="plus"/>
                  Dodaj
                </b-button>
              </div>
            </div>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Layout from '@/Layouts/Default'
import Header from '@/Layouts/Components/Header'
import Errors from '@/Layouts/Components/Errors'

export default {
  layout: Layout,
  components: {
    Errors,
    Header,
  },
  data() {
    return {
      form: this.$inertia.form({
        firstName: '',
        lastName: '',
      }),
    }
  },
  methods: {
    submit() {
      this.form.post(this.route('barbers.store'))
    },
  },
}
</script>
